import React, {useEffect} from 'react';

import PropTypes from 'prop-types';

import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function YesNoViewNewTemplate({
    question,
    message,
    onConfirm,
    onCancel,
    yesLabel = 'MODAL.YES_NO_CONFIRM_LABEL',
    noLabel = 'MODAL.YES_NO_CANCEL_LABEL',
    t,
    loading,
    loadingMessage,
    swapButtons,
    doNotShowCancel,
    compactMessage,
    iconClassName = 'modal-warning'
}) {
    return (
        <div>
            <div className='modal__wrap'>
            <KeyDownListener onConfirm={onConfirm}/>
            <i style={{ cursor: "default" }} className={`status--sqare ${iconClassName} u-radius--full`}></i>
            <h3 className='modal__header__title'>
                {t(question)}
            </h3>
            {message &&
                <p
                    className={`type--base u-padd--right--med ${compactMessage ? '' : 'u-mar--top--med'} type--color--secondary`}
                    style={compactMessage ? { marginTop: '-8px' } : undefined}
                >
                    {t(message)}
                </p>
            }
            {/* ISG-2723: optional progress line shown only while `loading`, for a Confirm that has to look something
                up before it can finish (e.g. "Checking for additional PSOs to credit..."). */}
            {loading && loadingMessage &&
                <p className='type--base u-padd--right--med u-mar--top--sml type--color--secondary'>
                    <i className='u-icon u-icon--sml u-icon--sync u-rotate--login u-mar--right--tny'></i>
                    {t(loadingMessage)}
                </p>
            }
            </div>

            <div className='modal__footer is-right'>
                {!doNotShowCancel && swapButtons &&
                    <BaasicButton
                    className='btn btn--med btn--light'
                        onClick={onCancel}
                        disabled={loading}
                        label={t(noLabel)}
                    />
                }
                <BaasicButton
                    className='btn btn--med btn--primary'
                    onClick={onConfirm}
                    disabled={loading}
                    rotate
                    icon={
                        loading
                            ? 'u-icon u-icon--xmed u-icon--sync u-rotate--login'
                            : 'u-display--none'
                    }
                    label={t(yesLabel)}
                />
                {!doNotShowCancel && !swapButtons &&
                    <BaasicButton
                    className='btn btn--med btn--light'
                        onClick={onCancel}
                        disabled={loading}
                        label={t(noLabel)}
                    />
                }
            </div>
        </div>
    );
}

YesNoViewNewTemplate.propTypes = {
    question: PropTypes.string,
    message: PropTypes.string,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    yesLabel: PropTypes.string,
    noLabel: PropTypes.string,
    loading: PropTypes.bool,
    loadingMessage: PropTypes.string,
    t: PropTypes.func,
    swapButtons: PropTypes.bool,
    doNotShowCancel: PropTypes.bool,
    compactMessage: PropTypes.bool,
    iconClassName: PropTypes.string
};

const KeyDownListener = ({ onConfirm }) => {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Enter") {
                onConfirm();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return null;
}
KeyDownListener.propTypes = {
};

export default defaultTemplate(YesNoViewNewTemplate);
